import {Card, theme, Typography} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const NoResults = ({text}) => {
  const {token}: any = theme.useToken();

  return (
    <Card
      style={{marginTop: 24, marginBottom: 24}}
      styles={{
        body: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '30vh',
        },
      }}>
      <Typography.Text style={{color: token.colorPrimary}}>{text}</Typography.Text>
    </Card>
  );
};

NoResults.propTypes = {
  text: PropTypes.string,
};

export default NoResults;
